import { Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import limpiarHtml from '../Compartido/limpiarHtml.js';
import CabeceraPagina from '../Compartido/CabeceraPagina.jsx';

const TextoPoliticas = ({ politicas, config, ruta }) => {
    let results = [];

    const { t } = useTranslation();

    return (
        <>
            <CabeceraPagina titulo={t("Política_de_cancelación")} eyebrow={t("Legal")} imagen={ruta + '/politicas/cabecera/cabecera.jpg'} compacto />

            <div className="bhe-ancho bhe-politicas mt-5 mb-5">
                <Tabs
                    defaultActiveKey="0"
                    id="uncontrolled-tab-example"
                    className="mb-5 bhe-tabs"
                >
                    {politicas.forEach((unapolitica, index) => {
                        results = results.concat(
                            <Tab eventKey={index} title={unapolitica.elnombre} key={index} >
                                <div dangerouslySetInnerHTML={{ __html: limpiarHtml(unapolitica.ladesc) }}></div>
                            </Tab>
                        )
                    })}

                    {results}
                </Tabs>
            </div>
        </>
    );
}

export default TextoPoliticas;
